import { render, staticRenderFns } from "./change.vue?vue&type=template&id=74b7a2bc&scoped=true&"
import script from "./change.vue?vue&type=script&lang=ts&"
export * from "./change.vue?vue&type=script&lang=ts&"
import style0 from "./change.vue?vue&type=style&index=0&id=74b7a2bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b7a2bc",
  null
  
)

export default component.exports